import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import PeanutButterProduct from 'models/PeanutButterProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState, textureOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const PeanutButterPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        PBTexture,
        PBContainerSize,
        otherTexture,
      } = current
      setPackaging({
        category,
        subCategory,
        PBTexture: {
          value: PBTexture || '',
          label: PBTexture.length > 0 ? PBTexture : 'Texture',
        },
        PBContainerSize: PBContainerSize || 16,
        otherTexture,
      })
    } else if (!updating) {
      setCurrent(PeanutButterProduct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.PBTexture === 'Other') {
        methods.setValue('otherTexture', current.otherTexture)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Texture {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={textureOptions}
          name="PBTexture"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Texture'}
          onChange={([selected]) => {
            setSelect(selected, 'PBTexture')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PBTexture"
            message={'⚠ Texture is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {current?.PBTexture === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Texture (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherTexture"
              placeholder={'Other Texture'}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 15,
                  message: '⚠ Other Texture exceeds 15 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherTexture"
                message={'Other texture is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
      </Col>
      <Col xs={6}>
        <p>
          <strong>Size {asterisk}</strong>
        </p>
        <Controller
          as={Input}
          name="PBContainerSize"
          placeholder={'16 - 18 ounces'}
          control={methods.control}
          rules={{
            validate: PBContainerSize =>
              PBContainerSize >= 16 && PBContainerSize <= 18,
            maxLength: {
              value: 5,
              message: '⚠ Size exceeds 5 characters.',
            },
          }}
          onKeyDown={e => {
            if (isNotNumericDecimal(e.key)) {
              e.preventDefault()
            }
          }}
          onChange={([event]) => {
            onChange(event)
            return event
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PBContainerSize"
            message={'⚠ Size must be between 16 - 18 ounces.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
      </Col>
    </Row>
  )
}

export default PeanutButterPackage
